export default __webpack_public_path__ + "static/media/Mariager Fjord (Dybet).9446b02d.xlsx";